import { LimitOrderCreator } from "./limitOrderCreator";

export class PostOnlyOrderCreator extends LimitOrderCreator {}
